function a(a,e,n,o){a._m(e);var f=n("38917e86");a._(e,"CatalogueInfoSlider",f);}